import type { BoardStage } from "app/components/Dashboard/DeliveryBoardColumn";

export function normalizeBoardStage(stage: Partial<BoardStage> | null | undefined): BoardStage {
  return {
    id: stage?.id ?? "unknown",
    title: stage?.title ?? "",
    color: stage?.color,
    items: Array.isArray(stage?.items) ? stage!.items : [],
  };
}

export function normalizeBoardStages(
  stages: Array<Partial<BoardStage> | null | undefined> | null | undefined
): BoardStage[] {
  if (!Array.isArray(stages)) {
    return [];
  }
  return stages.map((stage) => normalizeBoardStage(stage));
}
